import React from 'react'
import { toPage } from '../../utils'
import headerBg1 from '../../../assets/h5_banner_1.png'
import headerBg2 from '../../../assets/h5_banner_2.png'
import './index.less'
import { Swiper } from 'antd-mobile'

export default function() {
  return (
    <Swiper
      autoplay
      loop
    >
      <Swiper.Item key={'swiper_item_1'}>
        <div className="header-wrapper">
          <div
            className="header-wrapper-bg"
            style={{
              backgroundImage: `url(${headerBg1})`,
            }}
          >
            <div className="banner">
              <>
                <h1>加入国内领先的直播带货与数字营销平台</h1>
                <p>帮你把货卖给5亿+客户，携手共进，遥望未来</p>
                <div>
                  <button
                    onClick={() => {
                      toPage('为了更好的入驻体验，请前往PC端完成入驻')
                    }}
                  >
                    商家入驻
                  </button>
                </div>
              </>
            </div>
          </div>
        </div>
      </Swiper.Item>

      <Swiper.Item key={'swiper_item_2'}>
        <div className="header-wrapper">
          <div
            className="header-wrapper-bg"
            style={{
              backgroundImage: `url(${headerBg2})`,
            }}
          >
            <div className="banner">
              <>
                <h1>兴遥云仓仓配一体化服务</h1>
                <p>入仓权益【免保证金】【优先上播】【仓租可免】</p>
                <div>
                  <button
                  onClick={() =>
                    toPage('为了更好的体验，请前往PC端访问')
                  }
                  >
                    查看详情
                  </button>
                </div>
              </>
            </div>
          </div>
        </div>
      </Swiper.Item>
    </Swiper>
  )
}
